import { render, staticRenderFns } from "./MoneyBackGuarantee.vue?vue&type=template&id=519b09b9&"
import script from "./MoneyBackGuarantee.vue?vue&type=script&lang=ts&"
export * from "./MoneyBackGuarantee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports